//*********************************
// keen-slider
//*********************************

console.log('keen-slider');

import KeenSlider from 'keen-slider'

//*********************************
// https://keen-slider.io/examples
//*********************************


//*********************************
// function navigation
//*********************************

function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight

  function markup(remove) {
    wrapperMarkup(remove)
    dotMarkup(remove)
    arrowMarkup(remove)
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment)
  }
  function createDiv(className) {
    var div = document.createElement("div")
    var classNames = className.split(" ")
    classNames.forEach((name) => div.classList.add(name))
    return div
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft)
      removeElement(arrowRight)
      return
    }
    arrowLeft = createDiv("arrow arrow--left")
    arrowLeft.addEventListener("click", () => slider.prev())
    arrowRight = createDiv("arrow arrow--right")
    arrowRight.addEventListener("click", () => slider.next())

    wrapper.appendChild(arrowLeft)
    wrapper.appendChild(arrowRight)
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper)
      removeElement(wrapper)
      return
    }
    wrapper = createDiv("navigation-wrapper")
    slider.container.parentNode.appendChild(wrapper)
    wrapper.appendChild(slider.container)
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots)
      return
    }
    dots = createDiv("dots")
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv("dot")
      dot.addEventListener("click", () => slider.moveToIdx(idx))
      dots.appendChild(dot)
    })
    wrapper.appendChild(dots)
  }

  function updateClasses() {
    var slide = slider.track.details.rel
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled")
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled")
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active")
    })
  }

  slider.on("created", () => {
    markup()
    updateClasses()
  })
  slider.on("optionsChanged", () => {
    console.log(2)
    markup(true)
    markup()
    updateClasses()
  })
  slider.on("slideChanged", () => {
    updateClasses()
  })
  slider.on("destroyed", () => {
    markup(true)
  })
}

//*********************************
// keen-slider-1
//*********************************

if (document.getElementById("keen-slider-1")){
	var slider1 = new KeenSlider("#keen-slider-1", {
	  loop: true,
	})
}

//*********************************
// keen-slider-2
//*********************************

if (document.getElementById("keen-slider-2")){
	var slider2 = new KeenSlider("#keen-slider-2", {
	  loop: true,
	  slides: {
	    perView: 2,
	  },
	})
}

//*********************************
// keen-slider-3
//*********************************

if (document.getElementById("keen-slider-3")){
	var slider3 = new KeenSlider("#keen-slider-3", {
	  loop: true,
		}, [
		navigation
	])
}

//*********************************
// keen-slider-4
//*********************************

if (document.getElementById("keen-slider-4")){
	var slider4 = new KeenSlider(
	  "#keen-slider-4",
	  {
	    loop: true,
	  },
	  [
	    (slider) => {
	      let timeout
	      let mouseOver = false
	      function clearNextTimeout() {
	        clearTimeout(timeout)
	      }
	      function nextTimeout() {
	        clearTimeout(timeout)
	        if (mouseOver) return
	        timeout = setTimeout(() => {
	          slider.next()
	        }, 2000)
	      }
	      slider.on("created", () => {
	        slider.container.addEventListener("mouseover", () => {
	          mouseOver = true
	          clearNextTimeout()
	        })
	        slider.container.addEventListener("mouseout", () => {
	          mouseOver = false
	          nextTimeout()
	        })
	        nextTimeout()
	      })
	      slider.on("dragStarted", clearNextTimeout)
	      slider.on("animationEnded", nextTimeout)
	      slider.on("updated", nextTimeout)
	    }, navigation
	  ]
	)
}
